export default "__VITE_ASSET__DR2AUX_w__"